import useInfrastructure from "hooks/useInfrastructure.hook";
import { useChatSelected } from "hooks/chat/useChatSelected.hook";

export function useChatConversationSelected(id) {
  const { repositories } = useInfrastructure();
  const repository = repositories.conversations;

  return useChatSelected({
    id,
    repository
  });
}